/** @format */

import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";
import { REGIONS } from "./constants/constants";

function MarketOverviewCommodities(props) {
  const [editContent, setEditContent] = useState(false);
  const [temp, setTemp] = useState("");
  function handleSave(section) {
    section.content = temp;
    props.saveCommodityComments();
    setEditContent(false);
  }
  function handleCancel() {
    setEditContent(false);
  }
  // function contains(list, title){
  //   for(var i=0;i<list.length; i++){
  //     if(list[i].title===title) return true;
  //   }
  //   return false;
  // }

  return (
    <tr
      style={{
        fontSize: "16px",
        // color: "black",
        textAlign: "justify",
        margin: "10px",
      }}
    >
      <td valign='top'>
        <img
          alt='Commodity img'
          src={props.obj.imagePath}
          width='300'
          height='180'
          style={{
            borderRadius: "0px 50px 0px 50px",
            margin: "10px",
          }}
        />
      </td>
      <td valign='top' width='60%'>
        <div
          style={{
            color: props.businessUnit !== BUSINESS_UNIT.COCOA ? "#638C1C" : "#be621c",
            fontSize: "22px",
            fontWeight: "600",
            width: "50%",
          }}
        >
          {props.obj.title}
        </div>
        {props.publish === false && props.diff_date >= 0 ? (
          <span
            className='editContent'
            style={{ fontSize: "16px", color: "grey" }}
            onClick={() => {
              setEditContent(true);
              setTemp(props.obj.content);
              props.setEditing("marketOverview", true, false);
            }}
          >
            Edit Content
          </span>
        ) : (
          <></>
        )}

        <div
          style={{
            fontSize: "14px",
            // color: "#cccccc",
            whiteSpace: "pre-line",
            textAlign: "justify",
            wordBreak: "break-word",
          }}
        >
          {props.obj.content}
        </div>
      </td>

      <Dialog
        baseZIndex={10001}
        className='diag1'
        visible={editContent}
        style={{ width: "1000px" }}
        onHide={() => handleCancel()}
        focusOnShow={false}
      >
        <div className='diag-box'>
          <div className='grid'>
            <div className='col-12 p-0 diag-syndication'>{props.obj.title}</div>
            <div className='col-12 pl-0'>
              <InputTextarea
                required
                rows={20}
                value={temp}
                className='widthFull'
                onChange={(event) => setTemp(event.target.value)}
              />
            </div>
            <div className='col-12 flex-row-reverse flex'>
              <Button
                label='Cancel'
                className='p-button ml-2  p-button-sm diag-discard-button'
                onClick={() => handleCancel()}
              />
              <Button
                label='Save'
                onClick={() => handleSave(props.obj)}
                className='p-button ml-2  p-button-sm diag-save-button'
              />
              {(props.businessUnit === BUSINESS_UNIT.COCOA &&
                (props.region === REGIONS.SA_PG || props.region === REGIONS.SA_ES)) ||
                props.regions.map((reg) => {
                  if (reg.value !== props.region) {
                    return (
                      <Button
                        key={reg.value}
                        label={"Copy from " + reg.value}
                        onClick={() => {
                          setEditContent(false);
                          props.getContentBasedonDateAndRegion(
                            reg.value,
                            "Market Overview",
                            "current",
                            props.obj,
                            props.saveCommodityComments,
                            props.obj.title
                          );
                        }}
                        className='p-button ml-2  p-button-sm diag-save-button'
                      ></Button>
                    );
                  }
                  return <React.Fragment key={reg.value}></React.Fragment>;
                })}
              {/* { props.region!==REGIONS.NA && contains(props.NAList, props.obj.title) &&
               <Button
                  label="Copy from NA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion(REGIONS.NA, "Market Overview", 'current', props.obj, props.saveCommodityComments, props.obj.title)
                  }}
                  className="p-button ml-2  p-button-sm diag-save-button"
                />
              }
              { props.region!==REGIONS.EMEA && contains(props.EMEAList, props.obj.title) &&
               <Button
                  label="Copy from EMEA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion(REGIONS.EMEA, "Market Overview", 'current', props.obj, props.saveCommodityComments, props.obj.title)
                  }}
                  className="p-button ml-2  p-button-sm diag-save-button"
                />
              }
              { props.region!==REGIONS.SA && contains(props.SAList, props.obj.title) &&
               <Button
                  label="Copy from SA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion(REGIONS.SA, "Market Overview", 'current', props.obj, props.saveCommodityComments, props.obj.title)
                  }}
                  className="p-button ml-2  p-button-sm diag-save-button"
                />
              } */}
              <Button
                label='Copy from Yesterday'
                onClick={() => {
                  setEditContent(false);
                  props.getContentBasedonDateAndRegion(
                    props.region,
                    "Market Overview",
                    "previous",
                    props.obj,
                    props.saveCommodityComments,
                    props.obj.title
                  );
                }}
                className='p-button ml-2  p-button-sm diag-save-button'
              />
            </div>
          </div>
        </div>
      </Dialog>
    </tr>
  );
}
export default MarketOverviewCommodities;
